import { colors, Icon, IconButton } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { toggleForceToExpandNavigation } from '../NavigationContext';

import './Logo.css';

export const Logo = () => {
  const { t } = useTranslation('global');
  return (
    <div className="ml-4 flex items-center justify-between">
      <Icon
        name="spendesk"
        color={colors.contentPrimary}
        aria-hidden="true"
        size="l"
        className="ml-4 shrink-0"
      />
      <IconButton
        className="navigation-toggle-display text-content-primary"
        iconName="left-menu"
        aria-label={t('navigation.expandedOrCollapseNavigation')}
        onClick={() => {
          toggleForceToExpandNavigation();
        }}
      />
    </div>
  );
};
